import { render, staticRenderFns } from "./CloudShowItem.vue?vue&type=template&id=3b522cc8&scoped=true&"
import script from "./CloudShowItem.vue?vue&type=script&lang=ts&"
export * from "./CloudShowItem.vue?vue&type=script&lang=ts&"
import style0 from "./CloudShowItem.vue?vue&type=style&index=0&id=3b522cc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b522cc8",
  null
  
)

export default component.exports